<div class="header">
  <h2>Service Recommendation details</h2>
  <div class="header-buttons">
    <button mat-raised-button color="accent" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </div>
</div>

<loading-bar *ngIf="loading"></loading-bar>

<div *ngIf="serviceRecommendation">
  <p><strong matTooltip="MIB ID of the recommended service">Service Recommendation ID:</strong> {{ serviceRecommendation.Id }}</p>
  <p><strong matTooltip="MIB asset ID">MIB Asset ID:</strong> <asset-link [assetId]="serviceRecommendation.MibAssetId"/> </p>
  <p><strong>Source System Name:</strong> {{ serviceRecommendation.SourceSystemName }}</p>
  <p><strong>Source System ID:</strong> {{ serviceRecommendation.SourceSystemId }}</p>
  <p><strong>Source System Additional ID:</strong> {{ serviceRecommendation.SourceSystemAdditionalId }}</p>
  <p><strong matTooltip="Status of the recommended service. Scheduled when closure date is empty. Applied when closure date is set">Status:</strong> {{ serviceRecommendation.Status }}</p>
  <p><strong>Salesforce Opportunity ID:</strong> {{ serviceRecommendation.SalesForceOpportunityId }}</p>
  <p><strong>Salesforce Opportunity Number:</strong> {{ serviceRecommendation.SalesForceOpportunityNumber }}</p>
  <p><strong matTooltip="Planned date of the recommended service">Planned Date:</strong> {{ serviceRecommendation.PlannedDate | mibDate }}</p>
  <p><strong>Closure Date:</strong> {{ serviceRecommendation.ClosureDate | mibDate }}</p>
  <p><strong matTooltip="Date of the creation of recommendation">Created Date:</strong> {{ serviceRecommendation.CreatedDate | mibDateTime }}</p>
  <p><strong matTooltip="Date of the last modification of recommendation">Modified Date:</strong> {{ serviceRecommendation.ModifiedDate | mibDateTime }}</p>
  <p><strong matTooltip="Email of the person that last modified service recommendation">Modified By:</strong> {{ serviceRecommendation.ModifiedBy }}</p>
  <p><strong matTooltip="True if service recommendation is customized">Is customized:</strong> {{ serviceRecommendation.IsCustomized }}</p>
  <p><strong matTooltip="Name of the system that modified recommendation">Source of Customization:</strong> {{ serviceRecommendation.SourceOfCustomization }}</p>
  <p><strong>Type CID:</strong> {{ serviceRecommendation.Type?.Cid }}</p>
  <p><strong>Type Name:</strong> {{ serviceRecommendation.Type?.Name }}</p>
  <p><strong>Type Source System Name:</strong> {{ serviceRecommendation.Type?.SourceSystemName }}</p>
  <p><strong>Type Description:</strong> {{ serviceRecommendation.Type?.Description }}</p>
</div>

<p *ngIf="!loading && !serviceRecommendation">
  Cannot load serviceRecommendation recommendation
</p>